import { LOCALES } from '@marketplace/i18n';
import {
  appListI18n,
  noApplicationI18n,
  cardsI18n,
} from './components';

export const mainPageI18n = {
  [LOCALES.ENG]: {
    developer_add_app_button: 'Add App',
    developer_apps_count: 'Apps ({count})',
    developer_my_profile: 'My profile',
    developer_logout: 'Log out',
    ...appListI18n[LOCALES.ENG],
    ...noApplicationI18n[LOCALES.ENG],
    ...cardsI18n[LOCALES.ENG],
  },
};
